// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  /* background-color: #7030A0; */
  min-height: 100vh!important;
  min-width: 100vw!important;
}
.fondo {
  background-color: #071cd8;
  background-image: linear-gradient(20deg, #153d71 0%, #2262d0 50%, #e9f00c 100%);
  background-size: 300% 300%;
  animation: gradientAnimation 3s ease infinite;
  font-family: 'Montserrat'
}

.fondo_form_entrenamiento {
  background-color: #A23C2B;
  /* background-image: linear-gradient(20deg, #153d71 0%, #2262d0 50%, #e9f00c 100%); */
  background-size: 300% 300%;
  animation: gradientAnimation 3s ease infinite;
  font-family: 'Montserrat'
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.App-logo {
  width: 250px!important; /* Establece el ancho del logo en un 30% del ancho del viewport */
  /* height: auto!important; Asegura que la altura se ajuste automáticamente para mantener las proporciones */
  max-width: 100%!important; /* Asegura que el logo no se extienda más allá del 100% del ancho disponible */
  pointer-events: none;
}

.App-header {
  background-color: #7030A0;
  min-height: 100vh!important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
}


/* css de dragArea */
.file-upload-content {
  display: none;
  text-align: center;
}
.file-upload-input {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  /* height: 100%; */
  outline: none;
  opacity: 0;
  cursor: pointer;
}
.image-upload-wrap {
  background-color: #fff;
  position: relative;
  border-radius: 15px;
  height: 150px;
  /* width: 280px; */
  border: 2px solid #000;
  margin-left: 10px;
  margin-right: 10px;
}
.image-upload-wrap:hover {
  background-color: transparent;
  border: 4px dashed #fff;
  color: white;

}
.text-information {
  margin-top: 5px;
  text-align: center;
  
}
.fontSize{
  font-weight: 800;
}
.text-information:hover {
  color: white;
  
}

.imagenredonda {
border-radius: 15px;
border: white solid 2px;
max-width: 125px;
max-height: 100px;
min-height: 100px;
min-width: 125px;
}

.backgroundService{
background-color: #8297dd;
color:black;
}

.margenvolt{
  margin-top: -30px;
}

.custom-btn {
  border: 2px solid white; /* Añadir bordes blancos con grosor de 3px */
  /* background-color:#e9f00c; */
  /* Ajustar otros estilos según sea necesario */
}
.letra-standar{
  font-size: 1.2rem;
}
.text-left-important {
  text-align: left !important;
}
.progress2 {
  height: 35px;
  width: 100%;
  border: 1px solid #13fc02;
  border-radius: 5px;
  background-color: #e6f3fa;
  margin-bottom: 15px;
}

.progress-bar2 {
  height: 100%;
  background: #0ebd08;
  display: flex;
  align-items: center;
  transition: width 0.25s;
  border-radius: 5px;
}

.progress-bar-text2 {
  margin-left: 10px;
  font-weight: bold;
  color: #cce7f5;
}


.modal-custom {
  border-radius: 8px;
  width: 35%;
  height: 35%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

/* Estilos para el fondo de superposición del modal */
.overlay-custom {
  background-color: rgba(0, 0, 0, 0.5);
}

.cerrar-btn {
  width: 50%;
  margin: auto;
  display: flex;
  text-align: center; /* Alinea el texto horizontalmente */
  padding: 8px 16px; 
  justify-content: center;
  border-radius: 8px;
  border: solid 1px white;
  color: #fff;
}

.cerrar-btn-container {
  width: 100%;
  height:50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .largo-predeterminado{
  min-height: 100px;
} */

  @media (max-width:800px) {
    .ocultar { 
      display: none;
    }   
    .largo-predeterminado{
      min-height: 100px;
    }
    
  }
  @media (min-width:801px) {
    .largo-predeterminado{
      min-height: 80px;
    }
    
  }
  @media (max-width:800px) {
    .margenn { 
      display: grid;
  place-items: center; /* Centra verticalmente y horizontalmente los elementos */
  height: 90px;
    }   
  }

  @media (max-width:800px ) {
    .tamanio { 

  font-size: 40px;
    }   
  }

  .custom-input-file {
    background-color: #f7f742;
    color: #fff;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    margin: 0 auto 0;
    min-height: 15px;
    overflow: hidden;
    padding: 10px;
    position: relative;
    text-align: center;
    width: 400px;
    border-radius: 8px;
    border: #ffffff solid 2px;
  }
  
  .custom-input-file .input-file {
   border: 10000px solid transparent;
   cursor: pointer;
   font-size: 10000px;
   margin: 0;
   opacity: 0;
   outline: 0 none;
   padding: 0;
   position: absolute;
   right: -1000px;
   top: -1000px;
  }

  .fixed-button {
    position: absolute;
    top: 10px;
    right: 30px;
    z-index: 1000;
  }

  .padding-left-img {
    margin-left: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,+EAA+E;EAC/E,0BAA0B;EAC1B,6CAA6C;EAC7C;AACF;;AAEA;EACE,yBAAyB;EACzB,qFAAqF;EACrF,0BAA0B;EAC1B,6CAA6C;EAC7C;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,sBAAsB,EAAE,iEAAiE;EACzF,2GAA2G;EAC3G,yBAAyB,EAAE,8EAA8E;EACzG,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;;AAEd;AACA;EACE,eAAe;EACf,kBAAkB;;AAEpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;;AAEd;;AAEA;AACA,mBAAmB;AACnB,uBAAuB;AACvB,gBAAgB;AAChB,iBAAiB;AACjB,iBAAiB;AACjB,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB,WAAW;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB,EAAE,4CAA4C;EACrE,8BAA8B;EAC9B,8CAA8C;AAChD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,2CAA2C;AAC7C;;AAEA,qDAAqD;AACrD;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE,oCAAoC;EACxD,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;GAEG;;EAED;IACE;MACE,aAAa;IACf;IACA;MACE,iBAAiB;IACnB;;EAEF;EACA;IACE;MACE,gBAAgB;IAClB;;EAEF;EACA;IACE;MACE,aAAa;EACjB,mBAAmB,EAAE,yDAAyD;EAC9E,YAAY;IACV;EACF;;EAEA;IACE;;EAEF,eAAe;IACb;EACF;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;GACC,iCAAiC;GACjC,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,UAAU;GACV,eAAe;GACf,UAAU;GACV,kBAAkB;GAClB,cAAc;GACd,YAAY;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":[".App {\n  text-align: center;\n  /* background-color: #7030A0; */\n  min-height: 100vh!important;\n  min-width: 100vw!important;\n}\n.fondo {\n  background-color: #071cd8;\n  background-image: linear-gradient(20deg, #153d71 0%, #2262d0 50%, #e9f00c 100%);\n  background-size: 300% 300%;\n  animation: gradientAnimation 3s ease infinite;\n  font-family: 'Montserrat'\n}\n\n.fondo_form_entrenamiento {\n  background-color: #A23C2B;\n  /* background-image: linear-gradient(20deg, #153d71 0%, #2262d0 50%, #e9f00c 100%); */\n  background-size: 300% 300%;\n  animation: gradientAnimation 3s ease infinite;\n  font-family: 'Montserrat'\n}\n\n@keyframes gradientAnimation {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n.App-logo {\n  width: 250px!important; /* Establece el ancho del logo en un 30% del ancho del viewport */\n  /* height: auto!important; Asegura que la altura se ajuste automáticamente para mantener las proporciones */\n  max-width: 100%!important; /* Asegura que el logo no se extienda más allá del 100% del ancho disponible */\n  pointer-events: none;\n}\n\n.App-header {\n  background-color: #7030A0;\n  min-height: 100vh!important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n}\n\n\n/* css de dragArea */\n.file-upload-content {\n  display: none;\n  text-align: center;\n}\n.file-upload-input {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* height: 100%; */\n  outline: none;\n  opacity: 0;\n  cursor: pointer;\n}\n.image-upload-wrap {\n  background-color: #fff;\n  position: relative;\n  border-radius: 15px;\n  height: 150px;\n  /* width: 280px; */\n  border: 2px solid #000;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.image-upload-wrap:hover {\n  background-color: transparent;\n  border: 4px dashed #fff;\n  color: white;\n\n}\n.text-information {\n  margin-top: 5px;\n  text-align: center;\n  \n}\n.fontSize{\n  font-weight: 800;\n}\n.text-information:hover {\n  color: white;\n  \n}\n\n.imagenredonda {\nborder-radius: 15px;\nborder: white solid 2px;\nmax-width: 125px;\nmax-height: 100px;\nmin-height: 100px;\nmin-width: 125px;\n}\n\n.backgroundService{\nbackground-color: #8297dd;\ncolor:black;\n}\n\n.margenvolt{\n  margin-top: -30px;\n}\n\n.custom-btn {\n  border: 2px solid white; /* Añadir bordes blancos con grosor de 3px */\n  /* background-color:#e9f00c; */\n  /* Ajustar otros estilos según sea necesario */\n}\n.letra-standar{\n  font-size: 1.2rem;\n}\n.text-left-important {\n  text-align: left !important;\n}\n.progress2 {\n  height: 35px;\n  width: 100%;\n  border: 1px solid #13fc02;\n  border-radius: 5px;\n  background-color: #e6f3fa;\n  margin-bottom: 15px;\n}\n\n.progress-bar2 {\n  height: 100%;\n  background: #0ebd08;\n  display: flex;\n  align-items: center;\n  transition: width 0.25s;\n  border-radius: 5px;\n}\n\n.progress-bar-text2 {\n  margin-left: 10px;\n  font-weight: bold;\n  color: #cce7f5;\n}\n\n\n.modal-custom {\n  border-radius: 8px;\n  width: 35%;\n  height: 35%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* Estilos para el fondo de superposición del modal */\n.overlay-custom {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.cerrar-btn {\n  width: 50%;\n  margin: auto;\n  display: flex;\n  text-align: center; /* Alinea el texto horizontalmente */\n  padding: 8px 16px; \n  justify-content: center;\n  border-radius: 8px;\n  border: solid 1px white;\n  color: #fff;\n}\n\n.cerrar-btn-container {\n  width: 100%;\n  height:50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* .largo-predeterminado{\n  min-height: 100px;\n} */\n\n  @media (max-width:800px) {\n    .ocultar { \n      display: none;\n    }   \n    .largo-predeterminado{\n      min-height: 100px;\n    }\n    \n  }\n  @media (min-width:801px) {\n    .largo-predeterminado{\n      min-height: 80px;\n    }\n    \n  }\n  @media (max-width:800px) {\n    .margenn { \n      display: grid;\n  place-items: center; /* Centra verticalmente y horizontalmente los elementos */\n  height: 90px;\n    }   \n  }\n\n  @media (max-width:800px ) {\n    .tamanio { \n\n  font-size: 40px;\n    }   \n  }\n\n  .custom-input-file {\n    background-color: #f7f742;\n    color: #fff;\n    cursor: pointer;\n    font-size: 18px;\n    font-weight: bold;\n    margin: 0 auto 0;\n    min-height: 15px;\n    overflow: hidden;\n    padding: 10px;\n    position: relative;\n    text-align: center;\n    width: 400px;\n    border-radius: 8px;\n    border: #ffffff solid 2px;\n  }\n  \n  .custom-input-file .input-file {\n   border: 10000px solid transparent;\n   cursor: pointer;\n   font-size: 10000px;\n   margin: 0;\n   opacity: 0;\n   outline: 0 none;\n   padding: 0;\n   position: absolute;\n   right: -1000px;\n   top: -1000px;\n  }\n\n  .fixed-button {\n    position: absolute;\n    top: 10px;\n    right: 30px;\n    z-index: 1000;\n  }\n\n  .padding-left-img {\n    margin-left: 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
